import { NavLink, Outlet } from "react-router-dom";
import { useIntl } from "react-intl";
import ApplicationLayoutBodyNavigation from "@rio-cloud/rio-uikit/ApplicationLayoutBodyNavigation";
import SubNavigation from "@rio-cloud/rio-uikit/SubNavigation";
import BackofficeLayout from "../BackofficeLayout";

const BudgetPage = () => {
  const intl = useIntl();
  const submenu = (
    <ApplicationLayoutBodyNavigation>
      <SubNavigation
        navItems={[
          {
            key: "notification-users",
            route: (
              <NavLink to="/backoffice/budget/notification-users">
                {intl.formatMessage({ id: "intl-msg:backoffice.budget.notificationUsers" })}
              </NavLink>
            ),
          },
        ]}
      />
    </ApplicationLayoutBodyNavigation>
  );

  return (
    <BackofficeLayout submenu={submenu}>
      <Outlet />
    </BackofficeLayout>
  );
};

export default BudgetPage;

